const Form_showPrivacyPolicyForRegion = require("./Form_showPrivacyPolicyForRegion");

/**
 * @param form {HTMLFormElement}
 * @return {void}
 */
module.exports = function Form_showEMEAPrivacyPolicy(form) {
    Form_showPrivacyPolicyForRegion(form, "EMEA");
}